module.exports = __webpack_public_path__ + "static/media/CondimentsScreen.c9312a06.png";